export class EnumItemMD {
  private _name: string;
  private _displayName: string;
  private _description: string;
  private _value: number;

  constructor(name: string, value: number, displayName: string, description: string) {
    this._name = name;
    this._value = value;
    this._displayName = displayName;
    this._description = description;
  }

  public get name() { return this._name; }
  public get value() { return this._value; }
  public get displayName() { return this._displayName; }
  public get description() { return this._description; }
}
